import { AxiosResponseHeaders } from 'axios';
import { RoutingResponseDTO } from '../entities';

const routingDTOToRoutingAdapter = (data: RoutingResponseDTO, headers?: AxiosResponseHeaders) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { routingDTOToRoutingAdapter };
